<template>
	<BModal id="feesServiceDateModal" :title="title"
		ok-title="Yes" cancel-title="No"
		@ok="submit"
		@cancel="cancel"
		@close="cancel"
		@hide="cancel">
		<p>
			{{ message }}
		</p>
		<BRow v-if="fee?.service.booking.frequency === 'Fortnightly'" class="mt-2 mb-2">
			<BCol>
				<BFormCheckbox :model-value="rescheduleFortnights"
					class="d-inline mr-4"
					:value="true"
					:unchecked-value="false" @update:model-value="rescheduleFortnights = $event">
					Has the services fortnight been changed permanently?
				</BFormCheckbox>
			</BCol>
		</BRow>
		<p>
			{{ rescheduleMessage }}
		</p>
	</BModal>
</template>

<script>
	export default {
		name: 'FeesServiceDateModal',
		emits: ['reset-date'],
		data() {
			return {
				fee: null,
				rescheduleFortnights: false,
			}
		},
		computed: {
			message() {
				return 'Are you sure you want to update the service date?';
			},
			title() {
				return 'Update Service Date';
			},
			rescheduleMessage() {
				return this.fee?.service_date ? `Rescheduling a service into the future will make it disappear from your fees list and reappear on ${moment(this.fee.service.date, 'YYYY-MM-DD').format('DD/MM/YYYY')}` : '';
			}
		},
		mounted() {
			this.$eventBus.$on('feesServiceDateModal.open', (fee) => {
				this.fee = fee;
				this.$bvModal.show('feesServiceDateModal');
			});
		},
		beforeUnmount() {
			this.$eventBus.$off('feesServiceDateModal.show');
		},
		methods: {
			submit() {
				this.$axios.put(`/api/cleaner/fees/${this.fee.id}`, {
					date: this.fee.service_date,
					rescheduleFortnights: this.rescheduleFortnights,
				}).then(() => {
					toastr.success('The services date has been updated.')
					this.$eventBus.$emit('feesServiceDateModal.success', this.fee.id);
					this.$bvModal.hide('feesServiceDateModal');
				}).catch((error) => {
					if (error.response.status === 400 && error.response.data.message === 'This service date has already been changed once, please contact your team manager to change the date again.') {
						toastr.error(error.response.data.message);
					} else {
						toastr.error('There was an error updating the services date.');
					}
				})
			},
			cancel() {
				this.$emit('reset-date');
			}
		}
	}
</script>

<style scoped>

</style>
